export interface IEnkParProps {
  children: React.ReactNode
}

export function EnkPar(props: IEnkParProps) {
  const { children } = props
  return <p className="mt-2 text-sm leading-6 text-gray-500">{children}</p>
}
